import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Afastamento } from "../../models/afastamento";
import { IGetAfastamentosUseCase } from "../../../presentation/useCases/read/get_afastamentos_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAfastamentosUseCase
 */

export class GetAfastamentosUseCase extends BasePaginatedUseCase<Afastamento> implements IGetAfastamentosUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getAfastamentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getAfastamentos(idFuncionario, page, pageSize);

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}